  <form class="form-validation">
    <div class="modal-header bg-primary text-light">
      <h4 class="modal-title">
        Shower Profile Details
      </h4>
    </div>

    <div class="modal-body">
      <div class="row center">
        <div class="col">
            <label for="showerOutletType" class="form-label">Shower type</label>
            <select id="showerOutletType"  class="form-select" [ngModelOptions]="{standalone: true}" id="showerOutletType" [(ngModel)]="bsHeating.showerOutletType">
                <option *ngFor="let property of filterLookupCodes('showerOutletType')" [value]="property.lookupValue">
                {{ property.lookUpItem }}
                </option>
            </select>
            <label for="showerWWHRS" class="form-label">WWHRS Connection?</label>
            <select id="showerWWHRS"  class="form-select" [ngModelOptions]="{standalone: true}" id="showerWWHRS" [(ngModel)]="bsHeating.showerWWHRS">
                <option *ngFor="let property of filterLookupCodes('showerWWHRS')" [value]="property.lookupValue">
                {{ property.lookUpItem }}
                </option>
            </select>
        </div>
      </div>

    </div>

    <div class="modal-footer">
      <button type="button" *ngIf="isEdit" class="btn btn-outline-dark" (click)="addNew()">Add new</button>
      <button type="button" class="btn btn-outline-dark" (click)="close()">Close</button>
    </div>
  </form>
